import React, { Component } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Check } from 'lucide-react';
export function PmaaS() {
  const packages = [{
    name: 'Small',
    description: 'Einstieg ins professionelle PM',
    price: '1.490€ mtl.',
    priceNote: '+ MwSt.',
    features: ['Projektplanung in einer Session', 'eine Abstimmung pro Monat mit Projekt-Verantwortlichen', 'Monatlicher Statusbericht', 'Projektabschlussbericht und Übergabe in die Linie', 'Support per eMail'],
    color: 'bg-slate-50 border-slate-200'
  }, {
    name: 'Medium',
    description: 'Für wachsende Projektanforderungen',
    price: '2.490€ mtl.',
    priceNote: '+ MwSt.',
    features: ['erweiterte Projektplanung in zwei Sessions', '2-wöchentliche Abstimmung mit Projekt-Verantwortlichen', 'Monatlicher Statusbericht', 'Projektabschlussbericht, Übergabe in die Line und eine Session lessons learned', 'Support per eMail und Telefon / Teams'],
    color: 'bg-blue-50 border-blue-100',
    highlight: true
  }, {
    name: 'Large',
    description: 'Umfassende Betreuung',
    price: '3.990€ mtl.',
    priceNote: '+ MwSt.',
    features: ['erweiterte Projektplanung in zwei Sessions', 'wöchentliche Abstimmung mit Projekt-Verantwortlichen', 'zusätzlich 2-wöchentliche Abstimmung mit Projekt-Auftraggeber', 'Monatlicher Statusbericht', 'Projektabschlussbericht, Übergabe in die Linie und je eine Session lessons learned mit Auftraggeber und Team', 'Support per eMail und Telefon / Teams'],
    color: 'bg-slate-50 border-slate-200'
  }, {
    name: 'Individuell',
    description: 'Maximale Performance & Skalierung',
    price: 'Preis nach Absprache',
    priceNote: '',
    features: ['Multi-Projektmanagement', 'Strategische Beratung', 'Agile Transformation', 'Individuelle KPIs'],
    color: 'bg-blue-900 text-white border-blue-800'
  }];
  const handleOrderClick = (pkg: (typeof packages)[0]) => {
    const subject = `Anfrage: PMaaS Paket "${pkg.name}"`;
    const featuresList = pkg.features.map(f => `  - ${f}`).join('\n');
    const body = `Sehr geehrte Damen und Herren,

ich interessiere mich für das PMaaS Paket "${pkg.name}".

Paketdetails:
${featuresList}

Preis: ${pkg.price} ${pkg.priceNote}

Meine Kontaktdaten:
Firma: 
Ansprechpartner: 
Telefon: 
E-Mail: 

Projektinformationen:
Projektname: 
Geplanter Start: 
Besondere Anforderungen: 


Mit freundlichen Grüßen`;
    window.location.href = `mailto:info@ellnerconsult.de?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };
  const handleContactClick = () => {
    window.location.hash = '#/';
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }, 100);
  };
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 flex flex-col" data-id="element-232">
      <Header forceSolid={true} data-id="element-233" />
      <main className="flex-grow pt-32 pb-24 px-4 sm:px-6 lg:px-8" data-id="element-234">
        <div className="max-w-7xl mx-auto" data-id="element-235">
          {/* Intro Section */}
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-236">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-237">
              Projektmanagement as a Service
            </h1>
            <p className="text-xl text-slate-600 leading-relaxed" data-id="element-238">
              Wir bieten flexible Lösungen, die mit Ihren Anforderungen
              wachsen können. 
            </p> 
            <p className="text-xl text-slate-600 leading-relaxed" data-id="element-239">
             Jedes Paket wird über die geplante Projektlaufzeit abgeschlossen. Um Ihnen die maximale Flexibilität zu geben, sind die Pakete monatlich künd- oder verlängerbar.
            </p>
          </div>

          {/* Packages Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20" data-id="element-240">
            {packages.map(pkg => <div key={pkg.name} className={`rounded-2xl p-8 border flex flex-col ${pkg.color} ${pkg.highlight ? 'ring-2 ring-blue-500 shadow-lg scale-105 z-10' : 'shadow-sm'}`} data-id="element-241">
                <h3 className={`text-2xl font-bold mb-2 ${pkg.name === 'Individuell' ? 'text-white' : 'text-slate-900'}`} data-id="element-242">
                  {pkg.name}
                </h3>
                <p className={`text-sm mb-4 ${pkg.name === 'Individuell' ? 'text-blue-200' : 'text-slate-500'}`} data-id="element-243">
                  {pkg.description}
                </p>

                {/* Price */}
                <div className="mb-6" data-id="element-244">
                  <div className={`text-3xl font-bold ${pkg.name === 'Individuell' ? 'text-white' : 'text-slate-900'}`} data-id="element-245">
                    {pkg.price}
                  </div>
                  {pkg.priceNote && <div className={`text-sm ${pkg.name === 'Individuell' ? 'text-blue-200' : 'text-slate-500'}`} data-id="element-246">
                      {pkg.priceNote}
                    </div>}
                </div>

                <ul className="space-y-4 mb-8 flex-grow" data-id="element-247">
                  {pkg.features.map((feature, idx) => <li key={idx} className="flex items-start" data-id="element-248">
                      <Check className={`w-5 h-5 mr-3 flex-shrink-0 ${pkg.name === 'Individuell' ? 'text-blue-300' : 'text-blue-600'}`} data-id="element-249" />
                      <span className={`text-sm ${pkg.name === 'Individuell' ? 'text-blue-50' : 'text-slate-600'}`} data-id="element-250">
                        {feature}
                      </span>
                    </li>)}
                </ul>

                <button onClick={() => handleOrderClick(pkg)} className={`w-full py-3 px-4 rounded-lg font-medium transition-colors ${pkg.name === 'Individuell' ? 'bg-blue-700 hover:bg-blue-600 text-white' : pkg.highlight ? 'bg-blue-600 hover:bg-blue-700 text-white' : 'bg-white border border-slate-300 text-slate-700 hover:bg-slate-50'}`} data-id="element-251">
                  Anfragen
                </button>
              </div>)}
          </div>

          {/* Outro Section */}
          <div className="max-w-3xl mx-auto text-center bg-white p-10 rounded-2xl shadow-sm border border-slate-200" data-id="element-252">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-253">
              Noch unsicher welches Paket passt?
            </h2>
            <p className="text-lg text-slate-600 mb-8" data-id="element-254">
              Lassen Sie uns gemeinsam herausfinden, was Sie
              wirklich brauchen.
            </p>
            <button onClick={handleContactClick} className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-900 hover:bg-blue-800 transition-colors" data-id="element-255">
              Kontakt aufnehmen
            </button>
          </div>
        </div>
      </main>
      <Footer data-id="element-256" />
    </div>;
}